import React from 'react';
import { TextInput, NumberInput, DateInput, BooleanInput } from 'react-admin';

import Edit from '../common/views/Edit';
import SimpleForm from '../common/forms/SimpleForm';
import CostFrequencyInput from './inputs/CostFrequencyInput';


const CostEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="id" disabled />
            <CostFrequencyInput />
            <TextInput source="name" fullWidth />
            <TextInput source="vendor" />
            <TextInput source="category" />

            <NumberInput source="amount" />
            <NumberInput source="amount_min" />
            <NumberInput source="amount_max" />

            <NumberInput source="variation_pct" />
            <BooleanInput source="is_variable" />
            <DateInput source="start_date" />
            <DateInput source="end_date" />
        </SimpleForm>
    </Edit>
);

export default CostEdit;
